import { theme } from '../theme'
import { Mascot } from './Mascot'

/**
 * A peek inside the app, for the front page (design idea 3, 8 Oct 2026).
 *
 * A small phone showing one question, drawn with the app's own colours and
 * shapes rather than a screenshot: a screenshot of the real app would show
 * a real child's name and words, and this must never show anyone's child.
 * The question is a real kind the app asks (a synonym question), with the
 * right answer just picked, so a parent sees what a minute of practice
 * looks like.
 */
export function AppPeek({ width = 230 }: { width?: number }) {
  const s = width / 230
  const option = (word: string, picked = false) => (
    <div style={{
      border: `${2 * s}px solid ${picked ? theme.green : theme.border}`,
      background: picked ? theme.greenPale : '#fff',
      color: picked ? theme.greenDarker : theme.text,
      borderRadius: 10 * s, padding: `${8 * s}px ${10 * s}px`,
      fontSize: 14 * s, fontWeight: 700, display: 'flex', justifyContent: 'space-between',
    }}>
      <span>{word}</span>{picked ? <span>✓</span> : null}
    </div>
  )
  return (
    <div aria-label="What a question looks like in Word Sprout" role="img" style={{
      width, borderRadius: 30 * s, padding: 9 * s, background: '#2B1D14',
      boxShadow: '0 16px 40px rgba(21,32,43,0.18)', flexShrink: 0,
    }}>
      <div style={{
        borderRadius: 22 * s, background: theme.bg, padding: `${14 * s}px ${12 * s}px ${16 * s}px`,
        display: 'flex', flexDirection: 'column', gap: 8 * s,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 11 * s, fontWeight: 800, color: theme.muted }}>Question 4 of 10</span>
          <span style={{ fontSize: 11 * s, color: theme.faint }}>Meaning</span>
        </div>
        <div style={{ height: 6 * s, borderRadius: 99, background: theme.sand, overflow: 'hidden' }}>
          <div style={{ width: '40%', height: '100%', background: theme.green }} />
        </div>
        <div style={{
          background: '#fff', borderRadius: 14 * s, padding: `${12 * s}px`,
          border: `1px solid ${theme.borderWarm}`,
        }}>
          <div style={{ fontSize: 15 * s, fontWeight: 800, color: theme.text, lineHeight: 1.35, marginBottom: 10 * s }}>
            Which word means the same as <span style={{ color: theme.orangeDark }}>enormous</span>?
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 * s }}>
            {option('tiny')}
            {option('huge', true)}
            {option('quiet')}
            {option('early')}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 * s }}>
          <Mascot size={34 * s} mood="cheer" label="" animate={false} />
          <span style={{ fontSize: 13 * s, fontWeight: 800, color: theme.greenDarker }}>Yes, that is it!</span>
        </div>
      </div>
    </div>
  )
}
